// Modules
import React from 'react';
import i18n from 'i18n-react';

// Constants
import nl from './translations/nl.json';

function TranslationsStore(props) {
    const { language, children } = props;

    // Map of all available languages of the HUB admin
    // The string is associated with the corresponding imported language file
    const availableLanguages = { nl };

    // Set the language file based on the parsed language code
    let setLanguage = availableLanguages[language];

    // If the language file doesn't exist, set it to the default (Dutch)
    if (Object.keys(availableLanguages).indexOf(setLanguage) === -1) {
        setLanguage = availableLanguages.nl;
    }

    // Set the translations from the language file
    i18n.setTexts(setLanguage);

    return <>{children}</>;
}

export default TranslationsStore;
